////
/// ============================================================================
/// COMPONENT / Products Categories List
/// ============================================================================
///
/// @group components
////

export default () => {
    document.querySelectorAll('.widget_product_categories').forEach((container) => {
        let toggle = container.querySelector('.widget-title');
        let mainList = container.querySelector('.product-categories');

        if (toggle) {
            toggle.addEventListener('click', () => {
                mainList.classList.toggle('is-open');
            });
        }

        mainList.classList.add('is-open');
        container.querySelectorAll('li.cat-parent').forEach((li) => {
            // Genera la struttura HTML per il toggle
            let a = li.querySelector('li.cat-parent > a');
            let ul = li.querySelector('li.cat-parent > ul.children');
            let wrapper = document.createElement('div');
            let toggle = document.createElement('button');
            let open = false;

            ul.style.display = 'block';
            let ulHeight = ul.offsetHeight + 'px';
            ul.removeAttribute('style');

            wrapper.classList.add('cat-item_wrap');
            toggle.classList.add('cat-item_toggle');
            toggle.classList.add('c-chevron');

            a.parentNode.insertBefore(wrapper, a);
            wrapper.appendChild(a);
            wrapper.appendChild(toggle);
            toggle.innerHTML = '<svg viewBox="0 0 16 16"><g fill="none" stroke="currentColor" stroke-linecap="square" stroke-miterlimit="10" stroke-width="2"><path d="M2 2l12 12"></path><path d="M14 2L2 14"></path></g></svg>';

            // Prepare la categoria corrente
            if (li.classList.contains('current-cat') || li.classList.contains('current-cat-parent')) {
                toggle.classList.add('-is-open');
                ul.style.height = ulHeight;
                open = true;
            }

            let animate = false;
            toggle.addEventListener('click', () => {
                if (animate) {
                    return;
                }

                animate = true;

                if (open) {
                    ul.style.height = 0;

                    let transitionEnd = () => {
                        li.classList.remove('is-open');
                        toggle.classList.remove('-is-open');
                        animate = false;
                        open = false;
                        ul.removeEventListener('transitionend', transitionEnd);
                    };

                    ul.addEventListener('transitionend', transitionEnd);
                } else {
                    open = true;
                    li.classList.add('is-open');
                    toggle.classList.add('-is-open');
                    ul.style.height = 0;
                    setTimeout(() => {
                        ul.style.height = ulHeight;
                        animate = false;
                    });
                }
            });
        });
        mainList.classList.remove('is-open');
    });
}
